module.exports = __webpack_public_path__ + "img/help_blue.4dc914da.svg";